import {useMemo} from 'react';
import {ThemeConfig, ThemeTime, ThemeType} from './types';

// Create hook for using the provider
export const useThemeProvider = (
  themeTime: ThemeTime,
  theme: ThemeConfig,
): ThemeType => {
  return useMemo(
    (): ThemeType => ({
      colors: theme.colors[themeTime],
      radii: theme.radii,
      spacing: theme.spacing,
      typography: theme.typography,
      borders: theme.borders,
      devices: theme.devices,
      time: themeTime,
    }),
    [theme, themeTime],
  );
};
